import React, { useEffect, useRef, KeyboardEvent } from "react";
import { setRef } from "../../../lib/refs/refs";

interface OptInInputProps {
  isErrored: boolean;
  onChange: (value: boolean) => void;
  value: boolean;
  id?: string;
  ariaLabelledby?: string;
  ariaDescribedBy?: string;
  disabled?: boolean;
}

const OptInInput = ({
  isErrored,
  onChange,
  value,
  ariaLabelledby,
  ariaDescribedBy,
  id = "new",
  disabled = false,
}: OptInInputProps) => {
  const a = ariaLabelledby ? { "aria-labelledby": ariaLabelledby } : {};

  const inputRef = useRef<HTMLInputElement>(null);

  const handleOnClick = () => {
    if (inputRef.current) {
      onChange(!inputRef.current.checked);
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault(); // Prevent scrolling on spacebar
      handleOnClick();
    }
  };

  // NOTE: Dependency array omitted to account for use of resetRef(), as useEffect with dep arr
  // will only trigger on initial render leaving the refs empty, this replicates prior version
  // where ref callback would trigger with each re-render
  useEffect(() => {
    setRef("optIn", inputRef.current);
  });

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.checked = value;
    }
  }, [value]);

  return (
    <div className="sid-checkbox">
      <input
        className="sid-checkbox__input"
        id={`sid-opt-in__${id}`}
        name="sid-opt-in"
        type="checkbox"
        checked={value}
        ref={inputRef}
        aria-invalid={isErrored}
        aria-describedby={ariaDescribedBy}
        disabled={disabled}
        tabIndex={-1}
      />
      <span
        {...a}
        className={`sid-checkbox__input-like ${isErrored ? "sid-checkbox__input-like--error" : ""}`}
        onClick={handleOnClick}
        onKeyDown={handleKeyDown}
        role="checkbox"
        aria-checked={value}
        tabIndex={0}
        data-testid="stylable-checkbox-input"
      />
    </div>
  );
};

export const OptInInputComponent = OptInInput;
